export default {
  namespaced: true,
  state: {
    inquiryId: null,
    noticeId: null,
  },
  mutations: {
    SET_INQUIRY_ID(state, payload) {
      state.inquiryId = payload;
    },
    SET_NOTICE_ID(state, payload) {
      state.noticeId = payload;
    },
    INIT(state) {
      state.inquiryId = null;
      state.noticeId = null;
    }
  },
  getters: {
    getInquiryId(state) {
      return state.inquiryId;
    },
    getNoticeId(state) {
      return state.noticeId;
    }
  },
  actions: {
    setInquiryId({commit}, payload) {
      commit('SET_INQUIRY_ID', payload);
    },
    setNoticeId({commit}, payload) {
      commit('SET_NOTICE_ID', payload);
    },
    init({commit}) {
      commit('INIT');
    }
  }
}